import { tlReadyExecute } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AppDispatch } from '@doda/pc/src/redux/store';

/**
 * 検索TOP 「勤務地を選択」クリック計測
 * @param {boolean} isAdobeScript - AAスクリプト読み込みステータス
 * @param {AppDispatch} dispatch
 */
export const measureOnClickLocation = (
  isAdobeScript: boolean,
  dispatch: AppDispatch
) => {
  tlReadyExecute(isAdobeScript, dispatch, 'area_pr_pc', {
    linkTrackVars: 'prop23,eVar23',
    prop23: 'area_click',
    eVar23: 'D=c23',
  });
};

/**
 * 検索TOP 「路線・駅を選択」クリック計測
 * @param {boolean} isAdobeScript - AAスクリプト読み込みステータス
 * @param {AppDispatch} dispatch
 */
export const measureOnClickStation = (
  isAdobeScript: boolean,
  dispatch: AppDispatch
) => {
  tlReadyExecute(isAdobeScript, dispatch, 'area_st_pc', {
    linkTrackVars: 'prop23,eVar23',
    prop23: 'area_click',
    eVar23: 'D=c23',
  });
};
